export const ModuleType = Object.freeze({
	NativeDoor: 0, // Porta Nativa
	DoorModule: 1, // Módulo Porta
	RfReceiverModule: 2, // Módulo Receptor RF
	TurnstileModule: 8, // Módulo Catraca
	IpDoorModule: 12, // Módulo Porta Ip
	IpRfReceiverModule: 13, // Módulo Receptor RF Ip
	IpTurnstileModule: 14, // Módulo Catraca Ip
	IpParkModule: 16, // Módulo Estacionamento Ip
	KioskIpModule: 17, // Módulo Quiosque Ip
	// EdgeAiIpModule: 18, // Módulo Edge Ai Ip
});

export const ModuleIps = [
	ModuleType.IpDoorModule,
	ModuleType.IpRfReceiverModule,
	ModuleType.IpTurnstileModule,
	ModuleType.IpParkModule,
	ModuleType.KioskIpModule,
	// ModuleType.EdgeAiIpModule,
];

export const ModuleTypeText = Object.freeze({
	[ModuleType.NativeDoor]: "equipment.nativeDoor",
	[ModuleType.DoorModule]: "equipment.doorModule",
	[ModuleType.RfReceiverModule]: "equipment.rfReceiverModule",
	[ModuleType.TurnstileModule]: "equipment.turnstileModule",
	[ModuleType.IpDoorModule]: "equipment.ipDoorModule",
	[ModuleType.IpRfReceiverModule]: "equipment.ipRfReceiverModule",
	[ModuleType.IpTurnstileModule]: "equipment.ipTurnstileModule",
	[ModuleType.IpParkModule]: "equipment.ipParkModule",
	[ModuleType.KioskIpModule]: "equipment.kioskIpModule",
	// [ModuleType.EdgeAiIpModule]: "equipment.edgeAiIpModule",
});
